<template>
	<div class="width-100 height-100 flex-centerize flex-column">
		<h2 class="med">Didn’t find what you’re looking for?</h2>
		<div class="display-flex flex-row flex-align-center">
			<template v-if="useIsMarketplaceExactMatch">
				<h2 @click="tryABroadMatch" class="med create-button">Try a broad match</h2>
				<h2 class="med mx-1">or</h2>
			</template>
			<h2 @click="showWizard" class="med create-button">Create your own</h2>
		</div>
		<div class="mt-5 more-features">More features coming soon</div>
	</div>
</template>
<script>
import { useIsMarketplaceExactMatch } from '@/store/modules/marketplace/getters';
import { setIsMarketplaceExactMatch } from '@/store/modules/marketplace/actions';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'MarketplaceNoResults',
	computed: {
		...mapGettersShorthand({ useIsMarketplaceExactMatch }),
	},
	methods: {
		...mapActionsShorthand({ setIsMarketplaceExactMatch }),
		showWizard() {
			AppDialogManagerService.openCreationWizardDialog({ initialState: { autoSelectFirst: true } });
		},
		tryABroadMatch() {
			this.setIsMarketplaceExactMatch({ isMarketplaceExactMatch: false });
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="scss" scoped>
.more-features {
	letter-spacing: 0px;
	font-size: 18px;
	font-weight: medium;
	color: var(--primary-font-color);
}
.create-button {
	cursor: pointer;
	color: #605ed9;
	letter-spacing: 0.21px;
	text-decoration: underline;
}
</style>
